import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { QrCodeContainer } from '../containers/QrCodeContainer.js';

const QrCode = (props)=>/*#__PURE__*/ React.createElement(QrCodeContainer, swcHelpers.extends({}, props))
;

export { QrCode };
//# sourceMappingURL=QrCode.js.map
